__turbopack_context__.v({
  "input": "Checkbox-module__aT0fPa__input",
});
